export default {
  Bunn: {
    type: 'BUNN',
    scanCode: '*_tchls_coffee_*',
    name: 'Touchless Coffee Item',
  },
};
